import { render, staticRenderFns } from "./SponsorProcess.vue?vue&type=template&id=47f1aacd&scoped=true"
import script from "./SponsorProcess.vue?vue&type=script&lang=js"
export * from "./SponsorProcess.vue?vue&type=script&lang=js"
import style0 from "./SponsorProcess.vue?vue&type=style&index=0&id=47f1aacd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f1aacd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47f1aacd')) {
      api.createRecord('47f1aacd', component.options)
    } else {
      api.reload('47f1aacd', component.options)
    }
    module.hot.accept("./SponsorProcess.vue?vue&type=template&id=47f1aacd&scoped=true", function () {
      api.rerender('47f1aacd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/sendApproval/SponsorProcess.vue"
export default component.exports